module.exports = require('./lib/client');



//////////////////
// WEBPACK FOOTER
// ./~/feathers-primus/client.js
// module id = 433
// module chunks = 3